/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { keyframes } from "@emotion/react";
import MonthlyEarnings from "../components/dashboard/earning";
import ProductPerformance from "../components/dashboard/ProductPerformance";
import RecentTransactions from "../components/dashboard/RecentTransactions";
import SalesOverview from "../components/dashboard/SalesOverview";
import YearlyBreakup from "../components/dashboard/YearlyBreakup";
import StatusesPreview from "../components/dashboard/StatusesPreview";
import DashboardCard from "../components/dashboard/dashboardCard";
import {
  Box,
  CircularProgress,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import { get, post } from "../util/api";
import Page from "../components/Page";
import { Link } from "react-router-dom";
import { getDaysValue } from "../helper/generalControl";
import { countries } from "../helper/detailSettings";
import HealthMap from "../components/dashboard/healthMap";
import moment from "moment";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const dayToIndex = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

function daysUntilNext(dayName, time, timeType = "AM") {
  const targetDay = dayToIndex[dayName.toLowerCase()];
  const now = moment();
  const currentDay = now.day();

  let time24 = moment(`${time} ${timeType}`, "hh:mm A").format("HH:mm");

  const targetTime = moment()
    .day(targetDay)
    .set({
      hour: parseInt(time24.split(":")[0], 10),
      minute: parseInt(time24.split(":")[1], 10),
      second: 0,
      millisecond: 0,
    });
  if (
    targetDay < currentDay ||
    (targetDay === currentDay && now.isAfter(targetTime))
  ) {
    targetTime.add(7, "days");
  }
  return targetTime.diff(now, "days");
}

const pulse = keyframes`
  0% {
    opacity: 1;
    box-shadow: 0 0 40px #15a32a;
  }
  50% {
    opacity: 0;
    box-shadow: none;
  }
  100% {
    opacity: 1;
    box-shadow: 0 0 40px #15a32a;
  }
`;

const pulseRed = keyframes`
  0% {
    opacity: 1;
    box-shadow: 0 0 40px red;
  }
  50% {
    opacity: 0;
    box-shadow: none;
  }
  100% {
    opacity: 1;
    box-shadow: 0 0 40px red;
  }
`;

const HealthMapStatus = ({ servers }) => {
  let down = servers?.filter(
    (server) => server.server_settings.is_down
  )?.length;
  return (
    <div>
      {down > 0 ? (
        <span style={{ color: "#ca4024" }}>{down + " server(s) down"}</span>
      ) : !down && servers?.length ? (
        <span></span>
      ) : (
        <span style={{ color: "#15a32a" }}>100%</span>
      )}
    </div>
  );
};

const ListMaintenances = ({ servers }) => {
  if (!servers || servers.length === 0) {
    return (
      <span style={{ color: "white" }}>Not found upcoming maintenance</span>
    );
  }

  const upcomingMaintenances = [];

  servers.forEach((server, i) => {
    const { server_settings } = server;
    if (server_settings?.maintenances?.length > 0) {
      const { maintenances, link } = server_settings;

      maintenances.forEach((maintenance, index) => {
        const result = daysUntilNext(
          maintenance?.day,
          maintenance?.start,
          maintenance?.startType
        );
        if (result <= 3) {
          upcomingMaintenances.push({
            key: `maintenance-${i}-${index}`,
            link,
            day: maintenance.day,
            start: maintenance.start + " " + maintenance.startType,
            end: maintenance.end + " " + maintenance.endType,
            result,
          });
        }
      });
    }
  });

  return (
    <>
      {upcomingMaintenances.length > 0 ? (
        upcomingMaintenances.map((item) => {
          return (
            <div
              key={item.key}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 8,
                marginBottom: 4,
                color: "white",
              }}
            >
              <span>{item.link}</span>
              <Tooltip
                title={
                  <Box sx={{ p: 0 }}>
                    <pre>
                      <strong>Day:</strong> {item.day}
                    </pre>
                    <pre>
                      <strong>Start:</strong> {item.start}
                    </pre>
                    <pre>
                      <strong>End:</strong> {item.end}
                    </pre>
                  </Box>
                }
                arrow
                placement="top"
              >
                <HelpOutlineIcon
                  fontSize="small"
                  color="info"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </div>
          );
        })
      ) : (
        <span style={{ color: "white" }}>Not found upcoming maintenance</span>
      )}
    </>
  );
};

const IncidentsList = ({ incidents }) => {
  if (!incidents || incidents.length === 0) {
    return (
      <span style={{ color: "white" }}>Not found incidents in 3 days.</span>
    );
  }

  var __incidents__ = [];

  incidents.forEach((incident, i) => {
    const { date, extra } = incident;
    const { url, message, type, channel } = extra;

    __incidents__.push({
      key: `incidents-${i}`,
      date,
      url,
      message,
      type,
      channel,
    });
  });

  __incidents__ = _.sortBy(__incidents__, (o) => o.date).slice(0, 3);

  return (
    <>
      {__incidents__.length > 0 ? (
        __incidents__.map((item) => {
          return (
            <div
              key={item.key}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 8,
                marginBottom: 4,
                color: "white",
              }}
            >
              <span>{item.url}</span>
              <Tooltip
                title={
                  <Box sx={{ p: 0 }}>
                    <pre>
                      <strong>Message:</strong> {item.message}
                    </pre>
                    <pre>
                      <strong>Channel:</strong> {item.channel}
                    </pre>
                    <pre>
                      <strong>Type:</strong> {item.type}
                    </pre>
                    <pre>
                      <strong>Date:</strong> {item.date}
                    </pre>
                  </Box>
                }
                arrow
                placement="top"
              >
                <HelpOutlineIcon
                  fontSize="small"
                  color="info"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </div>
          );
        })
      ) : (
        <span style={{ color: "white" }}>Not found incidents in 3 days.</span>
      )}
      <Typography
        style={{
          textDecoration: "underline",
          color: "white",
          display: "block",
          textAlign: "left",
        }}
        mr={2}
        ml={0}
        mt={4}
        component={Link}
        to={`/incidents`}
      >
        Show More Incidents
      </Typography>
    </>
  );
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      servers_: [],
      days: 30,
      anchorEl: null,
      openPopover: false,
      server_country: "helsinki",
      load_more: false,
      incidents: [],
      uptimeloading: true,
    };
  }
  componentDidMount() {
    document.title = "Dashboard | Statusnap";
    this.getUptimes(this.state.server_country);
    this.getIncidents();
    if (window) {
      window.addEventListener("resize", this.handleResize, true);
      this.handleResize();
    }
  }

  handlePopoverOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, openPopover: true });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null, openPopover: false });
  };

  handleResize = () => {
    var day = 90;
    if (window && window.innerWidth) day = window.innerWidth;
    let res = getDaysValue(day);
    this.setState({ days: res });
  };

  componentWillUnmount() {
    if (window) window.removeEventListener("resize", this.handleResize, true);
  }

  calculateTimes(updatedAt, control) {
    control = control * 60;
    const now = new Date();
    const updatedDate = new Date(updatedAt);
    const timeDifferenceInMilliseconds = now - updatedDate;
    const timeDifferenceInSeconds = Math.floor(
      timeDifferenceInMilliseconds / 1000
    );

    return timeDifferenceInSeconds > control + 15 ? false : true;
  }

  async getUptimes(server, in_project) {
    this.handlePopoverClose();
    let { server_country } = this.state;
    let check = in_project || server_country || "helsinki";
    let found_country = _.find(countries, (a) => {
      if (a.key == check) {
        return a;
      }
    });

    this.setState({
      uptimeloading: true,
      found_country,
      server_country: in_project || server_country,
    });

    await post(`/statusnap/uptime/${server}`, {})
      .then((data) => {
        if (data && data.data && data.data.success) {
          let { data: data_ } = data.data;
          this.setState({ servers_: data_ });
        }
      })
      .catch((err) => {
        console.log(err);
      });

    this.setState({
      loading: false,
      uptimeloading: false,
    });
  }

  async getIncidents() {
    await get(`/statusnap/incidents/message`)
      .then((data) => {
        if (data && data.success) {
          let incidents = data.data;
          this.setState({
            incidents: incidents,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let { user, product } = this.props;
    let { subscription } = product;
    let { servers } = user;
    let { servers_, loading, days, server_country, found_country } = this.state;
    servers = servers?.filter((e) => e.type != "cluster");
    let disabled = servers.filter(
      (server) => server.server_settings.is_down
    ).length;
    if (!servers_ || (servers_.length == 0 && loading))
      return <Page.Loader key="loader" />;
    return (
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row", padding: 0 }}
      >
        <Box flex={{ xs: "1 1 auto", md: "0 0 75%" }}>
          <div style={{ marginBottom: 20 }}>
            <DashboardCard
              title="Region Health Map"
              action={<HealthMapStatus data={servers} />}
            >
              <Box sx={{ textAlign: "center" }}>
                <HealthMap />
              </Box>
            </DashboardCard>
          </div>
          <div style={{ marginBottom: 20 }}>
            <DashboardCard title="Monitors.">
              {!servers || servers.length == 0 ? (
                <Box sx={{ color: "white" }}>
                  {/* <Typography sx={{ color: "#ca4024" }}>
                    You don't have active monitors.
                  </Typography> */}
                  <Typography>
                    You don't have active monitors. Activate your monitors now!
                    Everything at your fingertips!
                  </Typography>
                  <Typography
                    style={{
                      textDecoration: "none",
                      color: " rgba(21, 163, 42, 1)",
                    }}
                    component={Link}
                    to={`/monitors/create`}
                  >
                    Try free now!
                  </Typography>
                </Box>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "-25px",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#a8a8a8",
                        fontSize: 13,
                        marginRight: "auto",
                      }}
                    >
                      {days} days history.
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      mb={2}
                      onClick={this.handlePopoverOpen}
                    >
                      <Box
                        component="img"
                        className="top-div"
                        sx={{
                          height: 20,
                          width: 20,
                          maxHeight: { xs: 20, md: 20 },
                          maxWidth: { xs: 20, md: 20 },
                          px: 0,
                          py: 0,
                        }}
                        alt={found_country.key + "img"}
                        src={found_country.img}
                      />
                      <Typography
                        sx={{ display: "inline-block", color: "#a8a8a8" }}
                        ml={1}
                      >
                        {found_country.value}
                      </Typography>
                      <Typography sx={{ color: "white", marginLeft: "5px" }}>
                        ▼
                      </Typography>
                    </Box>

                    <Popover
                      open={this.state.openPopover}
                      anchorEl={this.state.anchorEl}
                      onClose={this.handlePopoverClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      <Box sx={{ background: "#131a25" }}>
                        {_.map(countries, (e, i) => {
                          if (e.key == server_country)
                            return <div key={"non_countries" + i}></div>;
                          return (
                            <Box
                              key={"box_countries " + i}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                cursor: "pointer",
                                p: 1,
                              }}
                              onClick={() => {
                                this.getUptimes(e.key, e.key);
                              }}
                            >
                              <Box
                                component="img"
                                className="top-div"
                                sx={{
                                  height: 20,
                                  width: 20,
                                  maxHeight: { xs: 20, md: 20 },
                                  maxWidth: { xs: 20, md: 20 },
                                  px: 0,
                                  py: 0,
                                  mr: 1,
                                }}
                                alt={e.key + "img"}
                                src={e.img}
                              />
                              <Typography
                                key={e.key}
                                sx={{
                                  color:
                                    e.key == server_country
                                      ? "#a8a8a8"
                                      : "white",
                                }}
                              >
                                {e.value}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Popover>
                  </Box>
                  {this.state.uptimeloading ? (
                    <div
                      style={{
                        height: 255,
                        alignContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <CircularProgress
                        style={{
                          color: "white",
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      {!this.state.load_more ? (
                        <Box
                          sx={{
                            maxHeight: "255px",
                          }}
                        >
                          {_.map(servers.slice(0, 3), (e, i) => {
                            return (
                              <StatusesPreview
                                key={"preview-" + i}
                                data={e}
                                servers_={_.find(servers_, (a) => a.id == e.id)}
                                margin={"20px"}
                              />
                            );
                          })}
                        </Box>
                      ) : (
                        <Box
                          className="scroll-new"
                          sx={{
                            maxHeight: "255px",
                            overflowX: "auto",
                          }}
                        >
                          {_.map(servers, (e, i) => {
                            return (
                              <StatusesPreview
                                key={"preview-" + i}
                                data={e}
                                servers_={_.find(servers_, (a) => a.id == e.id)}
                                margin={"8px"}
                              />
                            );
                          })}
                        </Box>
                      )}
                    </>
                  )}

                  <div style={{ textAlign: "right" }}>
                    {!this.state.load_more ? (
                      <Typography
                        sx={{
                          color: "#a8a8a8",
                          cursor: "pointer",
                          "&:hover": {
                            color: "white",
                          },
                        }}
                        onClick={() => this.setState({ load_more: true })}
                      >
                        More Monitors.
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          color: "#a8a8a8",
                          cursor: "pointer",
                          "&:hover": {
                            color: "white",
                          },
                        }}
                        onClick={() => this.setState({ load_more: false })}
                      >
                        Less Monitors.
                      </Typography>
                    )}
                  </div>
                </>
              )}

              {/* <MonthlyEarnings />
        <br />
        <ProductPerformance />
        <br />
        <SalesOverview />
        <br />
        <YearlyBreakup /> */}
            </DashboardCard>
          </div>
        </Box>
        <Box
          flex={{ xs: "1 1 auto", md: "0 0 25%" }}
          pl={{ xs: 0, md: 3 }}
          pt={{ xs: 3, md: 0 }}
        >
          <DashboardCard title="Current Status">
            <Box sx={{ textAlign: "center" }}>
              <Box
                component="span"
                sx={{
                  ml: 1,
                  mr: 1,
                  display: "inline-block",
                  width: "3rem",
                  height: "3rem",
                  borderRadius: "50%",
                  backgroundColor: disabled ? "red" : "#15a32a",
                  animation: `${disabled ? pulseRed : pulse} 3s infinite`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  color: "white",
                  justifyContent: "space-between",
                  mt: 3,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    color: "#15a32a",
                  }}
                  flex={{ md: "0 0 33.4%" }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Up</Typography>
                  <Typography>
                    {
                      servers_.filter(
                        (server) =>
                          _.find(servers, (e) => e.id == server.id).active &&
                          this.calculateTimes(
                            server.updated_at,
                            _.find(servers, (e) => e.id == server.id).control
                          )
                      ).length
                    }
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    color: "#a8a8a8",
                  }}
                  flex={{ md: "0 0 33.4%" }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Paused</Typography>
                  <Typography>
                    {
                      servers_.filter(
                        (server) =>
                          !_.find(servers, (e) => e.id == server.id).active ||
                          !this.calculateTimes(
                            server.updated_at,
                            _.find(servers, (e) => e.id == server.id).control
                          )
                      ).length
                    }
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    color: "#ca4024",
                  }}
                  flex={{ md: "0 0 33.4%" }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Down</Typography>
                  <Typography>
                    {
                      servers.filter((server) => server.server_settings.is_down)
                        .length
                    }
                  </Typography>
                </Box>
              </Box>
              <Typography sx={{ color: "gray", mt: 2, fontSize: "13px" }}>
                Using {servers_.length} of {subscription.limit} monitors.
              </Typography>
            </Box>
          </DashboardCard>
          <div style={{ marginTop: 20 }}>
            <DashboardCard title="Upcoming Maintenance">
              <Box sx={{ textAlign: "left" }}>
                <ListMaintenances servers={servers} />
              </Box>
            </DashboardCard>
          </div>
          <div style={{ marginTop: 20 }}>
            <DashboardCard title="3 days of Recent Incidents">
              <Box sx={{ textAlign: "center" }}>
                <IncidentsList incidents={this.state.incidents} />
              </Box>
            </DashboardCard>
          </div>
        </Box>
      </Box>
    );
  }
}

export default connect((state) => ({
  user: state.access.user.loggedUserObj,
  product: state.product.undefined,
}))(Home);
